import Tool from '@/assets/js/utils.js'
// import SocketApi from '@/assets/js/websocket'
import $store from '@/store.js'
import axios from 'axios'
const session = window.localStorage.getItem('channelSession')
const randomCode = Tool.return32Str()
const protocol = document.location.protocol === 'https:' ? 'wss://' : 'ws://' // 获取协议
// 行为列表
const BehaviorList = {
  // 文件类
  '/fileInfoNew/add': 'MediaListChange', // 添加文件
  '/fileInfoNew/update': 'MediaListChange', // 更新文件
  '/fileInfoNew/delete': 'MediaListChange', // 删除文件
  '/playoutfolderNew/addFolder': 'MediaListChange', // 添加文件夹
  '/playoutfolderNew/editFolder': 'MediaListChange', // 更新文件夹
  // 事件类
  '/event/delete': 'EventListChange', // 删除事件
  '/event/add': 'EventListChange', // 添加事件
  '/event/updateEvent': 'EventListChange', // 更新事件
  '/event/takeNextEvent': 'EventListChange', // 下一个事件
  '/event/deleteEventByDay': 'EventListChange', // 删除一天事件
  '/event/copyEvents': 'EventListChange', // copy多个事件
  '/event/moveEvents': 'EventListChange', // move多个事件
  '/event/duplicateEvent': 'EventListChange', // copy一个时间段内多个事件
  '/event/addEventByTemplateId': 'EventListChange', // 添加模板事件
  '/template/userTemplate': 'EventListChange', // 添加模板事件
  // logo类
  '/logoTag/setLogo': 'LogoListChange', // 设置logo
  // crawl类
  '/crawl/setCrawl': 'CrawlListChange', // 设置crawl
  // event模板类
  '/eventTemplate/add': 'ProgramTemplateListChange', // 设置crawl
  '/eventTemplate/delete': 'ProgramTemplateListChange', // 设置crawl
  // 普通模板类
  '/template/saveAsTemplate': 'ScheduleTemplateListChange', // 设置crawl
  '/template/add': 'ScheduleTemplateListChange', // 设置crawl
  // scte类
  '/settingScte/addSettingScteEvent': 'SCTEListChange'
}
const Methods = {
  // 行为动作同步
  BehaviorWebsocket (type, prefix) {
    const businessId = this.getProgramId()
    prefix = prefix || ''
    if ($store.state.common.baseUrl.wsBaseUrl && session && businessId) { // 如果获取到url 并且获取到session之后才可以创建websocket
      const dataRequest = {
        url: `${protocol + $store.state.common.baseUrl.wsBaseUrl}/pageSerBusRequest?token=${session}&startModule=programOnlineModule&taskId=${prefix}${Tool.return32Str()}_q&businessId=${businessId}`,
        sendHeart: true,
        key: 'BehaviorWebsocket',
        success: (e) => {
          let data = e.data && JSON.parse(e.data)
          if (typeof data == 'object') {
            // 上线离线
            if (data && data.module == 'programOnlineModule') {
              window.vueBus.$emit('programOnlineChange', {
                action: 'programOnlineModule'
              })
            }
          } else if (data != 2) {
            data = data && JSON.parse(data)
            // 判断消息是否正确
            if (data && (data.module == 'ProgramBehavior' || data.module == 'playoutPreviewStatusModule')) {
              if (data.module == 'playoutPreviewStatusModule') {
                data.msg.action = 'playoutPreviewStatusModule'
              }
              // 判断消息是否是自己发出
              if (data.msg && data.msg.userCode != randomCode) {
                window.vueBus.$emit('BehaviorChange', data.msg)
              }
            }
          }
        }
      }
      if (type == 'off') {
        if ($store.state.websocket.BehaviorWebsocket) {
          $store.state.websocket.BehaviorWebsocket.off()
          $store.state.websocket.BehaviorWebsocket = null
        }
      }
      if (type != 'off' && !$store.state.websocket.BehaviorWebsocket) {
        $store.state.websocket.BehaviorWebsocket = new SocketApi(dataRequest)
        $store.state.websocket.BehaviorWebsocket.init()
        // $store.state.websocket.BehaviorWebsocket.socket.onmessage = (e) => BehaviorOnmessage(e)
        // $store.state.websocket.BehaviorWebsocket.socket.onmessage =
      }
      // $store.state.websocket.BehaviorWebsocket.socket.onclose = (e) => {
      //   this.SendBehavior('OffLine')
      // }
    }
    if (type == 'off') {
      if ($store.state.websocket.BehaviorWebsocket) {
        $store.state.websocket.BehaviorWebsocket.off()
        $store.state.websocket.BehaviorWebsocket = null
      }
    }
  },
  // 消息回调处理
  callBack () {},
  // 发送用户行为
  SendBehavior (type, NoUser) {
    const businessId = this.getProgramId()
    axios({
      url: '/gatewayPlayoutUrl/tvu-playout/userBehavior/command',
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        partyCode: businessId,
        module: 'ProgramBehavior',
        origin: window.vm.$route.path,
        msg: {
          action: type,
          userCode: NoUser ? randomCode + NoUser : randomCode,
          origin: window.vm.$route.path
        }
      }
    })
      .then((res) => {
      })
  },
  // 判断是什么操作
  JudgeOperationType (url) {
    if (typeof url == 'string') {
      const key = url.substr(url.lastIndexOf('/', url.lastIndexOf('/') - 1))
      if (BehaviorList[key]) {
        this.SendBehavior(BehaviorList[key])
      }
    }
  },
  // 获取programid
  getProgramId () {
    const ProgramRMessage = localStorage.getItem('ProgramRMessage')
    if (ProgramRMessage) {
      return JSON.parse(ProgramRMessage).ProgramId
    } else {
      return ''
    }
  },
  // 添加programId的接口字典
  InterfaceDictionary: {
    '/extra/getAllChildBookmarkTree': true,
    '/program/runningEventStatus': true, // 事件状态
    // '/scte/nextScte': true, // 下一个scte
    '/event/listEventByTR': true,
    '/event/delete': true,
    '/event/add': true,
    '/event/addEventByTemplateId': true,
    '/event/updateEvent': true,
    '/event/takeBreakSource': true,
    '/event/stopBreakSource': true,
    '/event/deleteEventByDay': true,
    '/event/copyEvents': true,
    '/event/moveEvents': true,
    '/event/takeNextEvent': true,
    '/event/duplicateEvent': true,
    '/eventTemplate/add': true,
    '/eventTemplate/update': true,
    '/eventTemplate/delete': true,
    '/eventTemplate/page': true,
    '/eventTemplate/getById': true,
    '/eventTemplate/resolveSegments': true,
    '/fileInfoNew/add': true,
    '/fileInfoNew/update': true,
    '/fileInfoNew/delete': true,
    '/playoutfolderNew/addFolder': true,
    '/playoutfolderNew/pageMedia': true,
    '/playoutfolderNew/getFolders': true,
    '/playoutfolderNew/deleteFolder': true,
    '/playoutfolderNew/getFolderAndMedias': true,
    '/playoutfolderNew/getFolderAndMediasByCondition': true,
    '/settingScte/addSettingScteEvent': true,
    '/template/add': true,
    '/template/saveAsTemplate': true, // 添加scte
    '/settingScte/page': true, // scte列表
    '/template/edit': true,
    '/template/listTemplate': true,
    '/template/userTemplate': true,
    '/logoTag/saveLogo': true,
    '/logoTag/setLogo': true,
    '/logoTag/logoInfo': true,
    '/BGC/getSwitchStatus': true, // BGC状态回显
    '/BGC/switch': true, // BGC状态设置
    '/extra/restartWebRtc': true, // 重连webrtc
    '/template/checkTemplateConflict': true
  }
}
export default Methods
